module.exports = __webpack_public_path__ + "img/news_31-03-2021.ede1684f.jpg";